import React, { useEffect, useRef, useState } from 'react';
import { ref, get } from 'firebase/database';
import { database } from './firebaseConfig';
import './PasswordScreen.css';
import { readCachedUser, cacheUser } from './userCache';

// Привітання за часом доби (укр., під мову застосунку)
function greetingByHour() {
  const h = new Date().getHours();
  if (h >= 5 && h < 12) return 'Доброго ранку';
  if (h >= 12 && h < 18) return 'Добрий день';
  if (h >= 18 && h < 21) return 'Добрий вечір';
  return 'Доброї ночі';
}

const PasswordScreen = ({ chatId, onSuccess }) => {
  const keys = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);
  const [storedPin, setStoredPin] = useState(null);
  const [pinLoaded, setPinLoaded] = useState(false);
  // Спливаючий червоний банер «Невірний ПІН»
  const [banner, setBanner] = useState(false);
  const [bannerClosing, setBannerClosing] = useState(false);
  const bannerTimers = useRef([]);

  const showErrorBanner = () => {
    bannerTimers.current.forEach(clearTimeout);
    bannerTimers.current = [];
    setBannerClosing(false);
    setBanner(true);
    bannerTimers.current.push(setTimeout(() => setBannerClosing(true), 2000));
    bannerTimers.current.push(setTimeout(() => setBanner(false), 2300));
  };

  useEffect(() => () => bannerTimers.current.forEach(clearTimeout), []);
  // Ім'я та аватар одразу з localStorage — щоб показувались миттєво,
  // не чекаючи відповіді Firebase.
  const [userPib, setUserPib] = useState(() => readCachedUser(chatId).pib);
  const [userPhoto, setUserPhoto] = useState(() => readCachedUser(chatId).photoUrl);

  const maxLength = 4;

  useEffect(() => {
    if (!chatId) return;
    get(ref(database, `users/${chatId}`))
      .then((snap) => {
        const user = snap.val() || {};
        setStoredPin(user.pin || null);
        setUserPib(user.pib || '');
        setUserPhoto(user.photoUrl || '');
        // оновлюємо кеш — з нього MainPage одразу візьме картку й ім'я
        cacheUser(chatId, user);
      })
      .catch(() => setStoredPin(null))
      .finally(() => setPinLoaded(true));
  }, [chatId]);

  const handleKeyClick = (num) => {
    if (error) return; // не даём вводить, пока идёт тряска после ошибки
    if (!storedPin) return; // PIN ще не завантажений або не встановлений
    if (pin.length < maxLength && num !== null) {
      const newPin = pin + num;
      setPin(newPin);

      if (newPin.length === maxLength) {
        if (newPin === storedPin) {
          setTimeout(() => {
            onSuccess(); // Передаём сигнал наверх
          }, 200); // Немного задержки для UX
        } else {
          setError(true);
          showErrorBanner();
          setTimeout(() => {
            setError(false);
            setPin('');
          }, 500); // длительность тряски
        }
      }
    }
  };

  const handleEraserClick = () => {
    setPin(pin.slice(0, -1));
  };

  // ПІБ у форматі «Прізвище Ім'я» — для привітання беремо ім'я (друге слово)
  const pibParts = (userPib || '').trim().split(/\s+/).filter(Boolean);
  const firstName = pibParts[1] || pibParts[0] || '';

  return (
    <div className="password-screen">
      {banner && (
        <div className={`pin-error-banner ${bannerClosing ? 'closing' : ''}`}>Невірний ПІН</div>
      )}
      <div
        className="avatar"
        style={{ backgroundImage: `url(${userPhoto || '/mono-avatar.webp'})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      />
      <h2 className="welcome">{greetingByHour()}{firstName ? `, ${firstName}` : ''}!</h2>
      <p className="instruction">
        {pinLoaded && !storedPin ? 'PIN-код не знайдено. Завершіть реєстрацію в боті (/start).' : 'Уведiть ПIН-код'}
      </p>

      {/* Кружочки для ПИНа */}
      <div className={`pin-indicator ${error ? 'shake' : ''}`}>
        {[...Array(maxLength)].map((_, i) => (
          <div
            key={i}
            className={`pin-dot ${i < pin.length ? 'filled' : ''} ${error ? 'error' : ''}`}
          />
        ))}
      </div>

      <div className="keypad">
  {keys.map((num) => (
    <div
      key={num}
      className={`key ${pin.includes(num.toString()) ? 'active' : ''}`}
      onClick={() => handleKeyClick(num)}
    >
      {num}
    </div>
  ))}
  <div className="key empty" />
  <div
    className={`key ${pin.includes('0') ? 'active' : ''}`}
    onClick={() => handleKeyClick(0)}
  >
    0
  </div>
  <div className="key icon-key" onClick={handleEraserClick}>
    <img src="/imgs/eraser.png" alt="eraser" className="icon" />
  </div>
</div>


      <div className="footer-con">
        <p className="footer-btn">Забули ПІН-код?</p>
      </div>
    </div>
  );
};

export default PasswordScreen;
